import React from 'react';
import PropTypes from 'prop-types';

import {
  START_DATE,
} from '@zr/utilities/profileFields';

import { STRING_FIELD_EXPERIENCE_START_MONTH } from '../labels';

import FormikLabeledField from './FormikLabeledField';
import MonthOptions from '../MonthOptions';

import formikPropTypes from './formikPropTypes';

export function StartMonthField({
  name, formikProps,
}) {
  const { errors } = formikProps;

  return (
    <FormikLabeledField
      as="select"
      // since the profile field is the date combined, also display errors with that field
      error={errors[name] || errors[START_DATE]}
      formikProps={formikProps}
      name={name}
      label={STRING_FIELD_EXPERIENCE_START_MONTH}
      placeholder={STRING_FIELD_EXPERIENCE_START_MONTH}
    >
      <MonthOptions />
    </FormikLabeledField>
  );
}

StartMonthField.propTypes = {
  name: PropTypes.string.isRequired,
  formikProps: formikPropTypes.isRequired,
};

export default StartMonthField;
